export const getUsersFrag = `
    id
    name
    surname
    email
    sex
    organizations {
        id
    }
    employments {
        serviceId
    }
`;

export const getUserGroupsFrag = `
    userId
    organizationId
    data
    group {
        id
        isPrivate
        rules {
            resource
            action
        }
    }
`;

export const getEmploymentsFrag = `
    id
    serviceId
`;
